import React from 'react';

// components
import AampeTooltip, {
    TooltipPlacement,
} from '../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

// constants
import aampeTheme from '../../constants/aampeTheme';

interface FormulaNameTooltipProps {
    text: string;
    className?: string;
    tooltipPlacement?: TooltipPlacement;
}

const FormulaNameTooltip: React.FC<
    React.PropsWithChildren<FormulaNameTooltipProps>
> = ({ text, tooltipPlacement = 'top', children }) => {
    return (
        <AampeTooltip
            title={
                <StyledSpan>
                    <strong>{text}</strong>

                    {
                        <span>
                            {
                                'The name of your Message Group. Pick a name that makes sense to you. ( NOTE: This name is not visible to customers.)'
                            }
                        </span>
                    }
                </StyledSpan>
            }
            arrow
            placement={tooltipPlacement}
        >
            <div>{children}</div>
        </AampeTooltip>
    );
};

const StyledSpan = styled.span(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(1),
    padding: aampeTheme.spacing(1),
}));

export default FormulaNameTooltip;
